import { render, staticRenderFns } from "./mo-month-year-selector-wrapper.html?vue&type=template&id=35bc38d3&external"
import script from "./mo-month-year-selector-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-month-year-selector-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports